<template>
  <div :class="htmlClass">
    <transition name="slide" mode="out-in">
      <slot />
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    htmlClass: String,
  },
  setup(props) {},
};
</script>

<style lang="scss" scoped>
.slide-enter-active,
.slide-leave-active {
  transition: opacity 0.3s ease-in-out;
}
.slide-enter-from,
.slide-leave-to {
  opacity: 0;
}

.slide-enter-to,
.slide-leave-from {
  opacity: 1;
}
</style>